import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import dayjs from 'dayjs'

import i18n from '@/i18n'
import { formatDateIntl } from '@/utils/date'
import { getCategories } from '@/modules/settings/views/account/reviews/api'

interface Props {
  dateRange: ComputedRef<dayjs.Dayjs>
  usedAutoQaCategories: ComputedRef<string[]>
}

export default function useAutoQaDateWarning({ dateRange, usedAutoQaCategories }: Props) {
  const { data } = useQuery({
    queryKey: [`autoqa-categories`],
    // @ts-expect-error - auto generated API type for AdvancedScorecard_GetCategoriesRequest incorrectly marks some fields as required
    queryFn: () => getCategories({ types: ['system', 'prompt', 'custom'] }),
    refetchOnMount: false,
  })

  const autoQaCategoriesCreatedAt = computed(() =>
    data.value?.data
      ?.filter(({ autoQaCategory }) => usedAutoQaCategories.value.includes(autoQaCategory ?? ''))
      .map(({ created }) => created),
  )

  const warningDate = computed(() => {
    if (!dateRange.value) return null

    const result = autoQaCategoriesCreatedAt.value
      .filter((createdAt) => dayjs(createdAt).utc().isAfter(dateRange.value.utc()))
      .sort((a, b) => (dayjs(a).isAfter(b) ? 1 : -1))
    return !!result?.length && result[0]
  })

  const warningMessage = computed(() => {
    if (!warningDate.value) return null

    return i18n.t('auto_qa.time_period_warning', {
      date: formatDateIntl(warningDate.value, { dateStyle: 'medium' }),
    })
  })

  return { warningMessage }
}
